<div class="to-top-container" [ngClass]="responsive.deviceAndOrientation">
    <div (click)="onTop()" class="to-top-wrapper">
        <div class="to-top-btn">
            <mat-icon
                svgIcon="chevron"
                style="color: black; transform: rotate(270deg)"
            ></mat-icon>
        </div>
        <div class="text title">Back to top</div>
    </div>
</div>
